import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Windows Task Manager.
 *
 * A singleton, as it always was: Ctrl+Alt+Del twice never gave you two of
 * them, it brought the one you already had to the front.
 *
 * Hidden from All Programs because taskmgr.exe was not in the Start menu —
 * it arrived by keyboard, from the taskbar's own context menu, or by being
 * typed into Run. All three of those routes work here.
 *
 * Takes no args.
 */
export const taskmgrApp: AppManifest = {
  id: 'taskmgr',
  name: 'Windows Task Manager',
  icon: '/assets/icons/taskmgr.svg',
  component: lazy(() => import('./Taskmgr')),

  // Tall enough that the Performance tab — the one with three stacked rows —
  // fits without scrolling at the default size.
  defaultSize: { w: 430, h: 486 },
  minSize: { w: 390, h: 340 },
  resizable: true,
  maximizable: true,
  singleton: true,

  showInAllPrograms: false,
  group: 'System',
  titleFor: () => 'Windows Task Manager',
};
